// @ts-nocheck
import {
    ThemeAttributesResponseData,
    getClass,
    getStackList,
    getStacks,
    getThemeAttributes,
    getThemeDetails,
    getCoursesPreview,
} from '@yandex-int/k-common/client/api';
import { apiConfig } from '@yandex-int/k-common/client/api/config';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import {
    CourseContainerClientData,
    LESSON_STATUS,
    Lesson,
    LessonProblem,
    Stack,
    Team,
    ThemeDetails,
} from '@yandex-int/k-common/typings';
//@ts-ignore
import dsl from '@yandex-int/k-common/utils/filtering-dsl/';
import { History } from 'history';
import first from 'lodash/first';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import map from 'lodash/map';
import xor from 'lodash/xor';
import { DEFAULT_PAGE_TO_LOAD } from 'platform-components/constants';
import { showNetworkError } from 'platform-components/src/components/notification/actions';
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import { reportMessage, getExactPathMatch } from 'platform-components/utils';
import qs from 'query-string';
import ym from 'react-yandex-metrika';
import { delay, all, call, fork, put, race, select, take, takeEvery, takeLatest } from 'redux-saga/effects';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { isLessonCompleted } from 'common.components/lesson/utils';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';
import { setWizardVariables } from 'common.components/user/actions';
import { getCurrentClass, getIsInOwnClass } from 'common.components/user/selectors';
import { actions as coursesActions } from 'store/courses/actions';
import * as themesSelectors from 'store/themes/selectors';
import { getTeamIdFromPath } from 'utils/path';

import { LIBRARY_CONTENT_TYPE, STACKS_CHUNK_SIZE } from '../library.common/constants';
import { objectKeysToCamelCase } from '../library.common/utils';

import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';
import { getFilterValues } from './selectors';

const REQUEST_DEBOUNCE_MS = 100;

function* getGrades() {
    // функция вызывается из другой саги и поэтому не надо оборачивать в try/catch
    const currentTeamId = getTeamIdFromPath();

    if (!currentTeamId) {
        const search = typeof window !== undefined ? window.location.search : '';
        const query = qs.parse(search);
        return query?.grade ? [query.grade] : undefined;
    }

    let currentClass: Team | null = yield select(getCurrentClass, { classId: currentTeamId });
    const isInOwnClass: boolean = yield select(getIsInOwnClass, { classId: currentTeamId });
    const isContentManager: boolean = yield select(getIsContentManager);

    if (!currentClass && isContentManager && !isInOwnClass) {
        // не используем getClassRequest, потому что нам не нужно сохранять эти данные в сторе
        // а то чужие классы со своими перепутаются

        currentClass = yield call(getClass, currentTeamId, {
            getPinAndPass: true,
            getParentIsBinded: true,
            getExpandBinded: true,
        });
    }

    const level = currentClass?.level;

    return level ? [level] : undefined;
}

export function* librarySagasWatcher() {
    yield all([
        debounce(REQUEST_DEBOUNCE_MS, constants.LOAD_STACKS_REQUEST, loadStacksSaga),
        takeEvery(constants.GET_STACK_PROBLEMS_REQUEST, getStackProblemsSaga),
        takeLatest(constants.GET_ALL_ATTRIBUTES_REQUEST, getAllAttributesSaga),
        takeLatest(constants.GET_AVAILABLE_ATTRIBUTES_REQUEST, getAvailableAttributesSaga),
        takeLatest(constants.APPLY_FILTER_FROM_URL, applyFilterFromUrlSaga),
        takeLatest(constants.CHANGE_FILTER_VALUE, changeFilterSaga),
        takeLatest(constants.CLEAR_FILTERS, clearFiltersSaga),
        takeLatest(constants.ADD_PROBLEM_TO_LESSON, addProblemToLessonSaga),
        takeEvery(constants.GET_THEME_DETAILS_REQUEST, getThemeInfoSaga),
        takeLatest(constants.SELECT_DEEP_LINK_STACK, selectDeepLinkStackSaga),
        takeLatest(constants.LESSON_MODAL_CLOSE, backToLibrarySaga),
        takeLatest(constants.SAVE_LESSON, saveLessonSaga),
        takeLatest(constants.ADD_NEW_SUBJECT, addNewSubjectSaga),
        takeLatest(constants.GET_COURSES_PREVIEW_REQUEST, getCoursesPreviewSaga),
    ]);
}

function* getStackProblemsSaga(action: ReturnType<typeof actions.getStackProblemsRequest>) {
    try {
        const { stacks, themeId } = action;
        const courseId: number | null = yield select(getCurrentYearCourseId);
        const stackIds: Array<number> = stacks.map((stack) => stack.id);
        const stacksWithRepresentative: any[] = yield call(getStacks, { stackIds, courseId: courseId || undefined });

        stacksWithRepresentative.forEach((stack: Stack) => {
            if (!stack.representative) {
                reportMessage(`Пустая стопка ${stack.id}!`);
            }
        });

        yield put(actions.getStackProblemsSuccess(stacksWithRepresentative, themeId));
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
        yield put(actions.getStackProblemsError(error));
    }
}

// загрузка всех фильтров(атрибутов для темы)
function* getAllAttributesSaga(action: ReturnType<typeof actions.getAllAttributesRequest>) {
    try {
        const { themeId } = action;
        const grades: [number] | undefined = yield getGrades();

        const attrs: ThemeAttributesResponseData = yield call(getThemeAttributes, themeId, {
            walkStacks: true,
            grades,
            // В теме не может быть больше 50 атрибутов
            // А если и будет больше - мы их не покажем
            // ToDo: сделать нормальную пагинацию
            pageSize: 50,
        });

        const list = attrs.filters.map(objectKeysToCamelCase);
        yield put(actions.getAllAttributesSuccess(themeId, list));
    } catch (e) {
        console.error(e);
    }
}

// загрузка фильтров(атрибутов для темы) с примененными фильтрами - часть становится не доступна
function* getAvailableAttributesSaga(action: ReturnType<typeof actions.getAvailableAttributesRequest>) {
    try {
        const { themeId } = action;
        const grades: [number] | undefined = yield getGrades();

        const filterValues: Record<string, string | string[]> = yield select(selectors.getFilterValues);
        const filter = mapFilters(filterValues);

        const attrs: ThemeAttributesResponseData = yield call(getThemeAttributes, themeId, {
            walkStacks: true,
            filter,
            grades,
            // В теме не может быть больше 50 атрибутов
            // А если и будет больше - мы их не покажем
            // ToDo: сделать нормальную пагинацию
            pageSize: 50,
        });

        const list = attrs.filters.map(objectKeysToCamelCase);
        yield put(actions.getAvailableAttributesSuccess(themeId, list));
    } catch (e) {
        console.error(e);
    }
}

// фильтрация контента
function* setFilterUrlSaga({ history }: { history: History }) {
    const filterValues: Record<string, string | string[]> = yield select(selectors.getFilterValues);
    const params = qs.parse(history.location.search, { arrayFormat: 'bracket' });

    history.push({
        search: qs.stringify({ ...params, filter: JSON.stringify(filterValues) }, { arrayFormat: 'bracket' }),
    });
}

function* applyFilterFromUrlSaga({ history }: ReturnType<typeof actions.applyFilterFromUrl>) {
    let filterFromUrl = {};

    try {
        const params = qs.parse(history.location.search, { arrayFormat: 'bracket' });
        filterFromUrl = JSON.parse(params.filter || '{}');
    } catch (e) {
        console.error(e);
    }

    /**
     * @deprecated временная проверка, чтобы при смене фильтров не моргали стопки
     */
    const currentFilters: Record<string, string | string[]> = yield select(selectors.getFilterValues);
    if (!isEqual(currentFilters, filterFromUrl)) {
        yield put(actions.clearStacks());
    }

    yield put(actions.setFilters(filterFromUrl));
}

function* changeFilterSaga({ filterSlug, filterValue, history }: ReturnType<typeof actions.changeFilterValue>) {
    const staticUrls = apiConfig.getStaticUrls();
    const prevFilterState: Record<string, string | string[]> = yield select(getFilterValues);
    const prevFilterValue = prevFilterState[filterSlug];
    const currentTeamId = getTeamIdFromPath();

    // изменяем значение фильтра
    yield put(actions.setFilterValue(filterSlug, filterValue));
    const exactPathMatch = getExactPathMatch(staticUrls, history.location.pathname);
    const { subject, themeId } = exactPathMatch?.params || {};
    const currentTeam: Team | null = yield select(getCurrentClass, { classId: currentTeamId });
    const currentFilterState: Record<string, string | string[]> = yield select(getFilterValues);

    yield setFilterUrlSaga({ history });

    ym('reachGoal', 'teacher_lesson_creation_intopic_filteruse', {
        subject,
        contentType: LIBRARY_CONTENT_TYPE.PROBLEMS,
        filterSlug,
        filterValue: first(xor(prevFilterValue, filterValue)),
        themeId,
        team_level: currentTeam?.level,
        filterAction: get(filterValue, 'length', 0) > get(prevFilterValue, 'length', 0) ? 'On' : 'Off',
        filterState: JSON.stringify(currentFilterState),
    });

    yield put(setWizardVariables({ filterClicked: true }));
}

function mapFilters(filterValues: Record<string, any>) {
    if (isNil(filterValues)) {
        return filterValues;
    }

    const dslFilterValues = map(filterValues, (attrValue, attrSlug) => {
        let filterValue;

        if (Array.isArray(attrValue)) {
            // атрибут enum
            const enumValue = attrValue.map((value) => ({
                attr_slug: attrSlug,
                attr_enum_slug: value,
            }));

            filterValue = dsl.filterBy('attributes').oneOf(...enumValue);
        } else {
            filterValue = dsl.filterBy('attributes').value({
                attr_slug: attrSlug,
                numeric_value: attrValue,
            });
        }

        return filterValue;
    });

    return dsl.logicAnd(...dslFilterValues);
}

function* loadStacksSaga(action: ReturnType<typeof actions.loadStacksRequest>) {
    try {
        const { themeId, page = DEFAULT_PAGE_TO_LOAD } = action;
        const filterValues: Record<string, string | string[]> = yield select(selectors.getFilterValues);
        const filters = mapFilters(filterValues);
        const grades: [number] | undefined = yield getGrades();

        let response: unknown = yield call(getStackList, {
            themeId,
            page,
            pageSize: STACKS_CHUNK_SIZE,
            filters,
            grades,
        });

        const stacks = get(response, 'results', []);
        const next = get(response, 'next', null);

        yield put(actions.loadStacksSuccess(stacks, themeId, page, next !== null));

        if (stacks.length > 0) {
            yield put(actions.getStackProblemsRequest(stacks, themeId));
        }

        // фильтры нужно грузить только один раз. Каждый раз при подгрузке следующей пачки стопок - чересчур
        if (page === DEFAULT_PAGE_TO_LOAD) {
            yield put(actions.getAvailableAttributesRequest(themeId));
        }
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
        yield put(actions.loadStacksError(error));
    }
}

function* clearFiltersSaga({ history }: ReturnType<typeof actions.clearFilters>) {
    yield put(actions.setFilters({}));

    yield setFilterUrlSaga({ history });
}

function* addProblemToLessonSaga(action: ReturnType<typeof actions.addProblemToLesson>) {
    try {
        const { problem, stackId } = action;
        let lesson: Lesson = yield select(lessonSelectors.getLesson);

        const insertIndex = lesson?.problems?.length || 0;
        yield put(
            lessonActions.insertProblems({
                index: insertIndex,
                problems: [{ id: problem.id, problem, type: 1, from_theme: stackId } as LessonProblem],
            })
        );
    } catch (error) {
        console.error(error);
        yield put(showNetworkError(error));
    }
}

function* getThemeInfoSaga(action: ReturnType<typeof actions.getThemeDetailsRequest>) {
    const { themeId } = action;
    try {
        const grades: [number] | undefined = yield getGrades();

        const themeDetails: ThemeDetails = yield call(getThemeDetails, themeId, grades);

        yield put(actions.getThemeDetailsSuccess(themeId, themeDetails));
    } catch (e) {
        // не пугаем пользователя ошибкой с актуальными темами
        const isActualTheme: boolean = yield select(themesSelectors.getIsActualTheme, { themeId });
        if (!isActualTheme) {
            yield put(showNetworkError(e));
            yield put(actions.getThemeDetailsError(e, themeId));
        }

        console.error(e);
    }
}

function* selectDeepLinkStackSaga({ stackId }: ReturnType<typeof actions.selectDeepLinkStack>) {
    try {
        const courseId: number | null = yield select(getCurrentYearCourseId);

        const [deepLinkStack]: Stack[] = yield call(getStacks, { courseId, stackIds: [stackId] });

        yield put(actions.setDeepLinkStack(deepLinkStack));
    } catch (e) {
        yield put(showNetworkError(e));
        console.error(e);
    }
}

function* backToLibrarySaga() {
    try {
        const isPreparedLesson: boolean = yield select(lessonSelectors.getIsPreparedLesson);
        const addLessonToCourseStatus: LOADING_STATUSES = yield select(lessonSelectors.getAddLessonToCourseStatus);
        const lessonStatus: LESSON_STATUS = yield select(lessonSelectors.getLessonStatus);
        const shouldClearLessonStore =
            (isPreparedLesson && addLessonToCourseStatus !== LOADING_STATUSES.LOADING) ||
            isLessonCompleted(lessonStatus);

        yield put(lessonViewActions.toggleModal(false));

        if (shouldClearLessonStore) {
            yield put(lessonActions.clearEditor());
        }
    } catch (e) {
        console.error(e);
    }
}

// Т.к. занятие сохраняется "автоматически" при любом изменении, то для опознания нового, не сохраненнного заведен флаг
// сбрасывается по кнопке "Сохранить" в модалке занятия
function* saveLessonSaga() {
    try {
        let lesson = (yield select(lessonSelectors.getLesson)) as unknown as any;
        lesson = lesson.set('isNew', false);

        yield put(lessonActions.setLesson(lesson));
    } catch (error) {
        console.error(error);
    }
}

function* addNewSubjectSaga(action: ReturnType<typeof actions.addNewSubject>): Generator {
    try {
        const { subject, onSuccess } = action.payload;
        yield put(
            teamBuilderActions.start({
                entryPoint: TEAM_BUILDER_ENTRY_STEPS.SUBJECTS,
                newSubject: subject,
            })
        );

        const params: unknown = yield race({
            addNewSubjectCancel: take(constants.ADD_NEW_SUBJECT_CANCEL),
            coursesData: take(coursesActions.getCoursesByTeamSuccess),
        });

        const { coursesData } = params as { coursesData?: ReturnType<typeof coursesActions.getCoursesByTeamSuccess> };

        if (coursesData?.payload.courses?.find((course) => course.subject === subject)) {
            if (onSuccess) {
                onSuccess();
            }
        }
    } catch (e) {
        yield put(showNetworkError(e));
        console.error(e);
    }
}

function* getCoursesPreviewSaga(_action: ReturnType<typeof actions.getCoursesPreviewRequest>) {
    try {
        const coursesPreview: CourseContainerClientData[] = yield call(getCoursesPreview);

        yield put(actions.getCoursesPreviewSuccess(coursesPreview));
    } catch (e) {
        yield put(showNetworkError(e));
        console.error(e);
        yield put(actions.getCoursesPreviewError());
    }
}

// from https://redux-saga.js.org/docs/api/#debouncems-pattern-saga-args
// Можно будет использовать из коробки, когда перейдем на версию >= 1.0.0
const debounce = (ms: number, pattern: string, task: any, ...args: any) =>
    fork(function* () {
        while (true) {
            let action: unknown = yield take(pattern);

            while (true) {
                const { debounced, latestAction } = yield race({
                    debounced: delay(ms),
                    latestAction: take(pattern),
                });

                if (debounced) {
                    yield fork(task, ...args, action);
                    break;
                }

                action = latestAction;
            }
        }
    });
